import dateFromArgs from '../helpers/date-from-args';
/**
 * This function takes two parameters. The first one is a string with
 * a valid date format.
 * By default, referenceDate is today.
 * If defined, referenceDate will be used as the referenceObj date
 * to check the date against instead of the current date.
 * This referenceDate is useful in testing.
 * @param {string} date
 * @param {string} referenceDate – Optional
 */
export default function isFutureDate(date, referenceDate) {
  const v = date.replace(/-/g, '/').split('/');
  const dateObj = dateFromArgs(v[0], v[1], v[2], 23, 59, 59);

  let refObj;

  if (referenceDate) {
    const r = date.replace(/-/g, '/').split('/');
    refObj = dateFromArgs(r[0], r[1], r[2]);
  } else {
    refObj = new Date();
  }

  return dateObj.getTime() > refObj.getTime();
}
